import { render, staticRenderFns } from "./DmaZonesStatisticsModal.vue?vue&type=template&id=0f1d3196&scoped=true&"
import script from "./DmaZonesStatisticsModal.vue?vue&type=script&lang=js&"
export * from "./DmaZonesStatisticsModal.vue?vue&type=script&lang=js&"
import style0 from "./DmaZonesStatisticsModal.vue?vue&type=style&index=0&id=0f1d3196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d3196",
  null
  
)

export default component.exports